import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import store from '@/store'
import ElementUI from 'element-ui'
import { Loading } from 'element-ui';
import { others,up } from '@/common'
import VueQuillEditor from '@/editor/config'
import * as echarts from 'echarts'
import sessionStorage from 'sessionstorage'
import axios from './axios'
import 'echarts-liquidfill'

import 'element-ui/lib/theme-chalk/index.css'
// import htmlToPdf from '@/common/htmlToPdf.js'
Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$axios = axios
Vue.prototype.$others = others
Vue.prototype.$echarts = echarts
Vue.prototype.$VueQuillEditor = VueQuillEditor
Vue.prototype.$up = up
Vue.prototype.$EventBus = new Vue()

Vue.use(ElementUI)
Vue.use(sessionStorage)
// Vue.use(htmlToPdf)
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
